import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Booking = lazy(() => import('../pages/booking/page'));
const NearbyShops = lazy(() => import('../pages/nearby-shops/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const PreLaunch = lazy(() => import('../pages/pre-launch/page'));
const PreLaunch1 = lazy(() => import('../pages/pre-launch1/page'));
const PreLaunch2 = lazy(() => import('../pages/pre-launch2/page'));
const PreLaunch3 = lazy(() => import('../pages/pre-launch3/page'));
const Community = lazy(() => import('../pages/community/page'));
const PostDetail = lazy(() => import('../pages/community/post-detail/page'));
const ShopDetail = lazy(() => import('../pages/shop-detail/page'));

// Service pages
const HairService = lazy(() => import('../pages/service/hair/page'));
const NailService = lazy(() => import('../pages/service/nail/page'));
const LashService = lazy(() => import('../pages/service/lash/page'));
const MakeupService = lazy(() => import('../pages/service/makeup/page'));
const SkincareService = lazy(() => import('../pages/service/skincare/page'));
const WaxingService = lazy(() => import('../pages/service/waxing/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/booking',
    element: <Booking />,
  },
  {
    path: '/nearby-shops',
    element: <NearbyShops />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/pre-launch',
    element: <PreLaunch />,
  },
  {
    path: '/pre-launch1',
    element: <PreLaunch1 />,
  },
  {
    path: '/pre-launch2',
    element: <PreLaunch2 />,
  },
  {
    path: '/pre-launch3',
    element: <PreLaunch3 />,
  },
  {
    path: '/community',
    element: <Community />,
  },
  {
    path: '/community/post/:postId',
    element: <PostDetail />,
  },
  {
    path: '/shop/:shopId',
    element: <ShopDetail />,
  },
  {
    path: '/service/hair',
    element: <HairService />,
  },
  {
    path: '/service/nail',
    element: <NailService />,
  },
  {
    path: '/service/lash',
    element: <LashService />,
  },
  {
    path: '/service/makeup',
    element: <MakeupService />,
  },
  {
    path: '/service/skincare',
    element: <SkincareService />,
  },
  {
    path: '/service/waxing',
    element: <WaxingService />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
